import { render } from "./FieldManagementIcon.vue?vue&type=template&id=385e940a"
import script from "./FieldManagementIcon.vue?vue&type=script&lang=js"
export * from "./FieldManagementIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__